module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_schweiz_it-3de0754403312c084e7fc9b56b2ee2b4.svg";